import React, { useEffect, useRef, useState } from 'react';
import Card from '../components/Card';
import { Add, CancelOutlined, Stairs, SchoolRounded } from '@mui/icons-material';
import CustomButton from '../components/Button';
import Carousel from 'react-material-ui-carousel'
import FadedBackgroundDiv from '../components/FadedBackground';
import Imbarchi from '../components/Imbarchi';
import FindImbarchi from '../components/FindImbarchi';
import OverlayedBackgroundDiv from '../components/OverlayedBackground';
import { InputLabel, useTheme, Fab, Menu, MenuItem, Modal, useMediaQuery,  Box, Typography, TextField, Button, Select, FormControl, Switch, Checkbox } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import History from '../helpers/History';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DemoContainer } from '@mui/x-date-pickers/internals/demo';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { ServerConfig } from '../connectors/Config';
import moment from 'moment';
import { config, S3} from 'aws-sdk';
import { Buffer } from "buffer";
import { AuthHelper } from '../helpers/AuthHelper';
import LoadingButton from '@mui/lab/LoadingButton';
import CardCertificati from '../components/CardCertificatiProfile';
import { CircularProgressbar, buildStyles } from 'react-circular-progressbar';
import { Fireworks } from '@fireworks-js/react'
import Alert from '@mui/material/Alert';
import it from 'dayjs/locale/it';
import AddAPhotoIcon from '@mui/icons-material/AddAPhotoOutlined';
import dayjs from 'dayjs';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import DownloadIcon from '@mui/icons-material/Download';
import ShareIcon from '@mui/icons-material/Share';
import PdfViewer from '../components/PdfViewer'
import Wave from '../components/WaveComponent.js';
import VisibilityIcon from '@mui/icons-material/Visibility';
import ToggleButton from '@mui/material/ToggleButton';
import ToggleButtonGroup from '@mui/material/ToggleButtonGroup';

import FormControlLabel from '@mui/material/FormControlLabel';
import FormLabel from '@mui/material/FormLabel';
import {loadStripe} from '@stripe/stripe-js';
import {PaymentElement, useStripe, useElements} from '@stripe/react-stripe-js';
import {Elements} from '@stripe/react-stripe-js';
import Radio from '@mui/material/Radio';
import RadioGroup from '@mui/material/RadioGroup';
import CardMaterial from '@mui/material/Card';
import CardActions from '@mui/material/CardActions';
import CardContent from '@mui/material/CardContent';
import DeleteIcon from '@mui/icons-material/Delete';

import { ChangeIMO } from '../components/ChangeIMO.js';

const style={
    container: {
        paddingLeft: 28, 
        paddingRight: 28,
        background: 'rgba(6,32,105,1)',
        height: 'auto',
        minHeight: '75vh',
        position: 'relative'
    }
}

const certificatesBST = [
    'af5b2947-8510-49a4-b8f4-b64359ddb975',
    'e28f429f-a579-429c-8b0b-8244b807271f',
    'b3200bf8-8863-4192-8ccb-700df8278d57',
    '4fe57438-4a04-4905-a800-3d14ec81bb52'
]

const fileConverterBase64 = (file) => {
    return new Promise((res, rej) => {
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = () => {
            res(reader.result)
        }
        reader.onerror = (err) => {
            rej(err)
        }
    })
}


const Profile = () => {
    const theme = useTheme(); 

    const isSmallScreen = useMediaQuery(theme.breakpoints.down('sm')); 
    const [pdf, setPdf] = useState(null);
    const [posizione, setPosizione] = React.useState('');
    const [isProcessing, setIsProcessing] = useState(false);

    const rolesPDF = {
        "79a01158-f54a-44fe-bd2e-bc9c2e9f7190": "https://documenti-app.s3.eu-west-1.amazonaws.com/LIBRETTO%20ADDESTRAMENTO%20COMUNI%20DI%20COPERTA.pdf",
        "3dc0c69e-c7f9-4928-84ec-6749b8e3716a": "https://documenti-app.s3.eu-west-1.amazonaws.com/LIBRETTO%20ADDESTRAMENTO%20COMUNI%20DI%20MACCHINA.pdf",
        "0dd2845f-0acf-4802-a779-b87bf062849c": "https://documenti-app.s3.eu-west-1.amazonaws.com/LIBRETTO%20ADDESTRAMENTO%20COPERTA.pdf",
        "257b8eb0-6bc5-44d6-b46c-e30394f43951": "https://documenti-app.s3.eu-west-1.amazonaws.com/LIBRETTO%20ADDESTRAMENTO%20MACCHINA.pdf",
        "63bf2b62-885c-479a-a155-fca9e4283423": "https://documenti-app.s3.eu-west-1.amazonaws.com/allievo%20ufficiale%20elettrotecnico%20bilingue%20completo%20REV06%2017%20nov%20%202020.pdf"
    }
    const handlePosizione = (
        event,
        newPosizione,
    ) => {
        setPosizione(newPosizione);
    };
    const [schoolSelectedCourse, setSchoolSelectedCourse] = React.useState({});
    const [secretStripe, setSecretStripe] = useState(null);
    const [paymentMethod, setPaymentMethod] = useState("Carta di credito");
    const createPaymentIntent = async(amount, course) => {
        console.log('creating payment intent ', amount);
        setSchoolSelectedCourse({...course});
        try{
            const res = await fetch('https://3vuz0d85jk.execute-api.eu-west-1.amazonaws.com/mase/api/v1/stripe/intent', {
                method: 'POST',
                body: JSON.stringify({amount: amount * 100})
            })
            const json = await res.json();

            setPaymentIntent(json.id);
            setSecretStripe(json.client_secret);
            setPaymentStep(2);

        }catch(ex){
            alert("Errore server");
        }
        
    }
    const CheckoutForm = () => {
        const stripe = useStripe();
        const elements = useElements();
        const ref = useRef();

        return (<form onSubmit={async (e) => {
            e.preventDefault(); 
            try{

                const user = await AuthHelper.getUserFromIdToken();
                const res = await fetch('https://3vuz0d85jk.execute-api.eu-west-1.amazonaws.com/mase/api/v1/prenotations', {
                    method: 'POST',
                    body: JSON.stringify({
                        profile: user.Username,
                        school: schoolSelectedCourse.school_id,
                        partecipant: user.Username,
                        payment: paymentIntent,
                        payment_status: 'COMPLETED',
                        accepted: true,
                        course_id: certificateSelected,
                        course: schoolSelectedCourse.id,
                        coursePayload: schoolSelectedCourse
                    })
                })
                const {error} = await stripe.confirmPayment({
                    elements,
                    confirmParams: {
                        return_url: `${window.location.origin}`,
                    },
                })
                if(error){
                    if (error.type === "card_error" || error.type === "validation_error") {
                        alert(error.message)
                    } else {
                        console.log(error);
                        alert('Errore server');
                        
                    }
                    return;
                }
              
               }catch(ex){
                console.log(ex);
    
                alert('ciao');
               }
            
            
            
            // setIsProcessing(false);
            }}> 
            <PaymentElement></PaymentElement>
            <button type="submit" loading={isProcessing}>{isProcessing ? 'Aspetta...' : 'Paga ora'}</button>
        </form>);
    }
    const StripeElement = () => {
        const options = {
            clientSecret: secretStripe
        }
        return <Elements stripe={stripePromise} options={options}>
                    <CheckoutForm />
                </Elements> 
    }
    const modalStyle = {
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        width: '85vw',
        bgcolor: 'background.paper',
        boxShadow: 24,
        overflow: 'scroll',
        maxHeight: '90vh',
        p: 3,
      };
    
      const modalStyleCertificate = {
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        width: '85vw',
        bgcolor: 'background.paper',
        boxShadow: 24,
        p: 3,
      };
      
      const modalStyleDocument = {
        position: 'absolute',
        left: '50%',
        top: '50%',
        transform: 'translate(-50%, -50%)',
        width: '90%',
        bgcolor: 'background.paper',
        boxShadow: 24,
        pr: 3,
        pl: 3,
        pt: 3,
        pb: 8,
        mb: 12,
        zIndex: 999
      };
    const NavigateSetter = () => {
        History.navigate = useNavigate();
        return null;
      }
    const navigate = useNavigate();
    const [open, setOpen] = React.useState(false);
    const [modalOpen, setModalOpen] = React.useState(false);
    const [anchorEl, setAnchorEl] = React.useState(null);
    const [courses, setCourses] = useState([]);
    const [certificates, setCertificates] = useState([]);
    const [loading, setLoading] = React.useState(false);
    const [nextRole, setNextRole] = useState({});
    const [schoolCourses, setSchoolCourses] = useState([]);

    const [avatar, setAvatar] = React.useState("/images/New Logo MASE  TR2 mod.png")
    const findSchools = async(certificate) => {
        console.log('CERTIFICATO', certificate);
        setCertificateSelected(certificate);
        const res = await fetch(`https://3vuz0d85jk.execute-api.eu-west-1.amazonaws.com/mase/api/v1/courses/certificate/${certificate}`)
        const courses = await res.json()
        setSchoolCourses([...courses.filter(x => moment(x.from).diff(moment()) > 0)]);
        setModalSchool(true);
    }
    const [certificateSelected, setCertificateSelected] = useState("");

    const [modalSchool, setModalSchool] = useState(false);

    const [bst, setBST] = useState(false);
    const [anchorElIMO, setAnchorElIMO] = React.useState(null);
    const openIMO = Boolean(anchorElIMO);

    const handleChange = async (e) => {
        setLoading(true);

        config.update({
            Region: ServerConfig.AWS.s3Bucket.Region, 
            credentials: {
                accessKeyId: ServerConfig.AWS.s3Bucket.AccessKeyId,
                secretAccessKey: ServerConfig.AWS.s3Bucket.SecretKeyId
            }});
        const s3 = new S3({apiVersion: ServerConfig.AWS.s3Bucket.ApiVersion, credentials: {
            accessKeyId: ServerConfig.AWS.s3Bucket.AccessKeyId,
            secretAccessKey: ServerConfig.AWS.s3Bucket.SecretKeyId
        }});
        try{
            const fileBase64 = await fileConverterBase64(e.target.files[0]);
            const fileParticles = fileBase64.split(',')[0];
            const fileName = `${dayjs().valueOf()}.document-file.${fileParticles.split(';')[0].split('/')[1]}`
            const params = {
                Bucket: ServerConfig.AWS.s3Bucket.BucketName,
                Key: fileName,
                Body: Buffer.from(fileBase64.split(',')[1], 'base64'),
                ContentType: e.target.files[0].type,
                ACL: 'public-read'
            };
            
            const res = await s3.putObject(params).promise();
            setDocument({...document, file: `https://new-mase.s3.eu-west-1.amazonaws.com/${fileName}`})
            setLoading(false);
        }catch(ex){
            console.log(ex);
            alert('Errore server')
        }
    };
    const getNextRole = async() => {
        try{
            const _user = (await AuthHelper.getUserFromIdToken())?.UserAttributes;
            const role = await fetch(`https://3vuz0d85jk.execute-api.eu-west-1.amazonaws.com/mase/api/v1/user/role/${_user.filter(x => x.Name === 'sub')[0]?.Value}`);
            setRole({...await role.json()});
            const res = await fetch(`https://3vuz0d85jk.execute-api.eu-west-1.amazonaws.com/mase/api/v1/user/current-role/${_user.filter(x => x.Name === 'sub')[0]?.Value}`)
            const next = await res.json();
            setNextRole({...next});
            console.log('PROSSIMO RUOLO: ', next)
            
        }catch(ex){

        }
       
    }
    const resetButton = async(e) => {
        const user = await AuthHelper.getUserFromIdToken();

        const res = await fetch(`https://3vuz0d85jk.execute-api.eu-west-1.amazonaws.com/mase/api/v1/user/reset/${user.Username}`, {
            method: 'PUT',
        });

        if(res.status === 200){
            alert('Profilo resettato');
            window.location.reload();
        }else{
            alert('Errore server');

        }
    }
    const logoutButton = async(e) => {
        localStorage.clear();
        sessionStorage.clear();
        window.location.href ='/login';
    }
    const handleAvatarChange = async (e) => {
        setLoading(true);

        config.update({
            Region: ServerConfig.AWS.s3Bucket.Region, 
            credentials: {
                accessKeyId: ServerConfig.AWS.s3Bucket.AccessKeyId,
                secretAccessKey: ServerConfig.AWS.s3Bucket.SecretKeyId
            }});
        const s3 = new S3({apiVersion: ServerConfig.AWS.s3Bucket.ApiVersion, credentials: {
            accessKeyId: ServerConfig.AWS.s3Bucket.AccessKeyId,
            secretAccessKey: ServerConfig.AWS.s3Bucket.SecretKeyId
        }});
        try{
            const fileBase64 = await fileConverterBase64(e.target.files[0]);
            const fileParticles = fileBase64.split(',')[0];
            const fileName = `${dayjs().valueOf()}.document-file.${fileParticles.split(';')[0].split('/')[1]}`
            const params = {
                Bucket: ServerConfig.AWS.s3Bucket.BucketName,
                Key: fileName,
                Body: Buffer.from(fileBase64.split(',')[1], 'base64'),
                ContentType: e.target.files[0].type,
                ACL: 'public-read'
            };
            const fileRes = await s3.putObject(params).promise();
            const user = await AuthHelper.getUserFromIdToken();
            const res = await fetch(`https://3vuz0d85jk.execute-api.eu-west-1.amazonaws.com/mase/api/v1/user/profile/${user.Username}`, {
                method: 'PUT',
                body: JSON.stringify({
                    avatar: `https://new-mase.s3.eu-west-1.amazonaws.com/${fileName}`
                })
            });
            setAvatar(`https://new-mase.s3.eu-west-1.amazonaws.com/${fileName}`);
            setLoading(false);
        }catch(ex){
            console.log(ex);
            alert('Errore server')
        }
    };
    const hiddenFileInput = useRef(null);
    const hiddenAvatarInput = useRef(null);

    const handleClick = (event) => {
        hiddenFileInput.current?.click();
    };

    const [document, setDocument] = React.useState({
        name: "",
        number: "",
        released: "",
        expire: ""
    });


    const [modalProfile, setModalProfile] = useState(false);
    const [fileModal, setFileModal] = useState(false);
    const [role, setRole] = useState("");
   
    const [_user, _setUser] = useState([]);
    const [profile, setProfile] = useState({
        first_name: "",
        last_name: "",
        nation: "",
        address: "",
        civic_number: "",
        passport: "",
        fiscal_code: "",
        birthplace: "",
        birthday: "",
        compartment: "",
        release: "",
        gender: "",
        phone_number: "",
        city: "",
        province: "",
        birth_province: "",
        city_residence: "",
        available: false
    })
    const [documents, setDocuments] = useState([]);
    const [imo, setImo] = useState(null);
    const [certificate, setCertificate] = useState({
        number: "",
        release: dayjs(),
        expiry: "",
        pdf: "",
    })
    const [bandiera, setBandiera] = React.useState('italiana');
    const [paymentStep, setPaymentStep] = useState(0);
    const stripePromise = loadStripe('pk_test_lVZtGpDyaeKuZ2I7z5MpDILw00jaFAxbxk')
    const [paymentIntent, setPaymentIntent] = useState(null);
    function downloadPdf(pdfUrl) {
        fetch(pdfUrl)
          .then(response => response.blob())
          .then(blob => {
            // Create a blob URL for the PDF data
            var url = window.URL.createObjectURL(blob);
      
            // Create a link element to trigger the download
            var a = window.document.createElement("a");
            a.href = url;
            a.download = "downloaded.pdf"; // Set the desired file name
            window.document.body.appendChild(a);
      
            // Trigger a click event on the link element to initiate the download
            a.click();
      
            // Clean up by revoking the blob URL and removing the link element
            window.URL.revokeObjectURL(url);
            window.document.body.removeChild(a);
          })
          .catch(error => {
            console.error("Failed to download the PDF file: ", error);
          });
      }
    const getCertificates = async() => {
        try{
            const user = await AuthHelper.getUserFromIdToken();
            const res = await fetch(`https://3vuz0d85jk.execute-api.eu-west-1.amazonaws.com/mase/api/v1/user/certificates?user=${user.Username}`);
            setCertificates([...await res.json()]);
        }catch(ex){

        }
    }
    const loadExternalCourse = (id) => {
        setCertificate({...certificate, course: id})
        setModalOpen(true);
    }
    const postProfile = async() => {
        const user = await AuthHelper.getUserFromIdToken();
        const regex = /^[A-Za-z]{6}[0-9]{2}[A-Za-z]{1}[0-9]{2}[A-Za-z]{1}[0-9]{3}[A-Za-z]{1}$/;
        if(!regex.test(profile.fiscal_code)){
            alert("Codice fiscale non valido!");
            setLoading(false);
            return;
        }
        const res = await fetch(`https://3vuz0d85jk.execute-api.eu-west-1.amazonaws.com/mase/api/v1/user/profile/${user.Username}`, {
            method: 'PUT',
            body: JSON.stringify(profile)
        });
        window.location.reload();
    }

    const getProfile = async() => {
        const user = await AuthHelper.getUserFromIdToken();
        const res = await fetch(`https://3vuz0d85jk.execute-api.eu-west-1.amazonaws.com/mase/api/v1/user/profile/${user.Username}`)
        let profile = await res.json();
        if(profile){
            delete profile.onboarded;
        }
        setProfile({...profile});
    }

    useEffect(() => {
        calculatePercentage();
    }, [nextRole])
    const loadCertificate = async() => {
        try{
            setLoading(true);
            const user = await AuthHelper.getUserFromIdToken();
            const ids = certificates?.map(x => x.course);
            console.log(ids);
            console.log('CHECK', ids.includes(certificate.course) && !certificate.id);
            if(ids.includes(certificate.course) && !certificate.id){
                alert("Il corso è già presente nel tuo profilo!");
                setLoading(false);
                return;
            }
               
            if(!moment(certificate.release).isValid() && !moment(certificate.expiry).isValid()){
                alert("Inserisci delle date valide!");
                setLoading(false);
                return;
            }
            if(moment(certificate.expiry).diff(moment()) < 0){
                alert("Non puoi caricare un certificato scaduto!");
                setLoading(false);
                return;
            }

            const res = await fetch('https://3vuz0d85jk.execute-api.eu-west-1.amazonaws.com/mase/api/v1/user/certificates', {
                method: 'POST',
                body: JSON.stringify({...certificate, user: user.Username})
            })
            setLoading(false);
            window.location.reload();
            console.log(res);
        }catch(ex){

        }
    }

    const [roleId, setRoleId] = useState("");

    const getUser = async () => {
        
        const __user = (await AuthHelper.getUserFromIdToken())?.UserAttributes;
        if(!_user)window.location.href="/login"
        _setUser([...__user])

        const getRole = await fetch(`https://3vuz0d85jk.execute-api.eu-west-1.amazonaws.com/mase/api/v1/user/role/${__user.filter(x => x.Name === 'sub')[0]?.Value}`)
        const json = await getRole.json();
        setRole(json.role);
        console.log('IMO', json.imo)
        setImo(json.imo);
        setRoleId(json.roleId);
    }
   
    const findDocuments = async() => {
        try{
            const user = await AuthHelper.getUserFromIdToken();
            const res = await fetch(`https://3vuz0d85jk.execute-api.eu-west-1.amazonaws.com/mase/api/v1/user/profile/documents/${user.Username}`);
            setDocuments([...await res.json()]);
        }catch(ex){
            console.error('ERRORE', ex);
        }
        
    }

    const [completedPercentage, setCompletedPercentage] = useState(0);

    const [completedProfilePercentage, setCompletedProfilePercentage] = useState(0);

    const calculatePercentage = () => {
        console.log(profile);
        let profilePercentage = 0;
        for(let key of Object.keys(profile)){
            if(profile[key] !== ""){
                if(profile[key] && key !== 'id' && key !== 'createdAt' && key !== 'updatedAt'){
                    profilePercentage += 1;
                }
            }
        }
        console.log('Percentuale profilo: ', profilePercentage);
        
        profilePercentage = profilePercentage / 7;
        console.log('Percentuale profilo: ', profilePercentage);

        setCompletedProfilePercentage(profilePercentage);

        let coursePercentage = nextRole?.remainingCourses?.filter(x => x["obbligatorieta'"] === 'true').length > 0 
            ? nextRole?.remainingCourses?.filter(x => x["obbligatorieta'"] === 'true').length / 10 : 1;
        // coursePercentage = nextRole?.remainingCourses?.filter(x => x["obbligatorieta'"] === 'true').length <= 0 ? 1 : nextRole?.remainingCourses?.filter(x => x["obbligatorieta'"] === 'true').length
        let documentsPercentage = documents?.filter(x => x.name === 'Codice Fiscale' || x.name === 'Carta d\'identità' || x.name === 'Passaporto' || x.name === 'Libretto di navigazione' || x.name === "Foglio provvisorio").length / 3;
        if(documentsPercentage > 1) documentsPercentage = 1;
        const _completedPercentage = (coursePercentage + profilePercentage + documentsPercentage) / 3;
        console.log('Percentuale divisa: ', coursePercentage, documentsPercentage, profilePercentage);
        // console.log('Percentuale completa: ', completedPercentage * 10);
        setCompletedPercentage(_completedPercentage);
        setTimeout(() => {
        console.log('Percentuale completa: ', completedPercentage);
            
        }, 1000)

    }
    useEffect(() => {
        getProfile()
        getUser();
        findDocuments();
        getNextRole();
        getCertificates();
        getCourses();
        window.document.querySelector('header').style.display = 'none';
        window.setTimeout(() => {
            if(window.document.querySelector('#alert-role')){
                window.document.querySelector('#alert-role').style.top = 0;
            }
        }, 800)
        
    }, [])

    const loadDocument = async() => {
        setLoading(true);
        const user = await AuthHelper.getUserFromIdToken();
        if(documents.filter(x => x.name === document.name).length > 0){
            alert("Hai già inserito questo documento");
            setLoading(false);
            return;
        }
        if(document.name === 'Codice Fiscale'){
            const regex = /^[A-Za-z]{6}[0-9]{2}[A-Za-z]{1}[0-9]{2}[A-Za-z]{1}[0-9]{3}[A-Za-z]{1}$/;
            if(!regex.test(document.number)){
                alert("Codice fiscale non valido!");
                setLoading(false);
                return;
            }
        }
        await fetch(`https://3vuz0d85jk.execute-api.eu-west-1.amazonaws.com/mase/api/v1/user/profile/document/${user.Username}`, {
            method: 'PUT',
            body: JSON.stringify(document)
        });
        setLoading(false);
        window.location.reload();
    }

    const openFileModal = async(name) => {
        setOpen(false);
        setDocument({...document, name});
        setFileModal(true);
    }
    const getCourses = async() => {
        try{
            const res = await(await fetch('https://3vuz0d85jk.execute-api.eu-west-1.amazonaws.com/mase/api/v1/certificates')).json();
            console.log(res);    
            setCourses([...res]);  
        }catch(ex){

        }
        
    }
    function a11yProps(index) {
        return {
        id: `simple-tab-${index}`,
        'aria-controls': `simple-tabpanel-${index}`,
        };
    }

    const [value, setValue] = React.useState(0);
    const handleChangeTab = (event, newValue) => {
        setValue(newValue);
      };

    const [openChangeRole, setOpenChangeRole] = React.useState(false);
    
    function CustomTabPanel(props) {
        const { children, value, index, ...other } = props;
    
        return (
            <div
            role="tabpanel"
            hidden={value !== index}
            id={`simple-tabpanel-${index}`}
            aria-labelledby={`simple-tab-${index}`}
            {...other}
            >
            {value === index && (
                <Box sx={{ p: 3 }}>
                <Typography>{children}</Typography>
                </Box>
            )}
            </div>
        );
    }
    const [showPdf, setShowPdf] = useState(false)
    return (<div style={{marginTop: -50}}>

        <ChangeIMO open={openChangeRole} setOpen={setOpenChangeRole} />
        <NavigateSetter />
        <Modal
                open={modalSchool}
                onClose={() => setModalSchool(false)}
                aria-labelledby="modal-modal-title"
                aria-describedby="modal-modal-description"
            >
                <Box sx={modalStyle}>
                    {paymentStep === 0 && <>
                        <Typography variant="h6" component="h2" sx={{mb: 2}}>
                            Autocertifica la tua posizione
                        </Typography>
                        <ToggleButtonGroup
                            value={posizione}
                            exclusive
                            onChange={handlePosizione}
                            aria-label="text posizione"
                        >
                            <ToggleButton value="primo_imbarco" aria-label="left aligned">
                                Primo imbarco
                            </ToggleButton>
                            <ToggleButton value="sbarcato" aria-label="centered">
                                Sbarcato
                            </ToggleButton>
                            <ToggleButton value="imbarcato" aria-label="right aligned">
                                Imbarcato
                            </ToggleButton>
                        </ToggleButtonGroup>
                        <div style={{marginTop: 6, marginBottom: 6}}>
                            <FormControl>
                            <FormLabel id="demo-radio-buttons-group-label">Bandiera Imbarco</FormLabel>
                                <RadioGroup
                                    aria-labelledby="demo-radio-buttons-group-label"
                                    defaultValue="italiana"
                                    name="radio-buttons-group"
                                    value={bandiera}
                                    onChange={(e) => setBandiera(e.target.value)}
                                >
                                    <FormControlLabel value="italiana" control={<Radio />} label="Bandiera Italiana" />
                                    <FormControlLabel value="estera" control={<Radio />} label="Bandiera Estera" />
                                </RadioGroup>
                            </FormControl>
                        </div>
                        <ToggleButtonGroup
                        color="primary"
                        value={paymentMethod}
                        exclusive
                        onChange={(e) => {
                            setPaymentMethod(e.target.value);
                        }}
                        >
                        <ToggleButton value="Carta di credito">Carta di credito</ToggleButton>
                        <ToggleButton value="Bonifico">Bonifico</ToggleButton>
                        <ToggleButton value="In sede">In sede</ToggleButton>
                        </ToggleButtonGroup><br />
                        {certificatesBST.includes(certificateSelected) && <FormControlLabel disabled={bst} onChange={async (e, newValue) => {
                            setBST(newValue);
                            setCertificateSelected('d54ca14d-79b5-4c12-9cdf-3ba3c7ba06d0');
                            await findSchools('d54ca14d-79b5-4c12-9cdf-3ba3c7ba06d0');
                        }} value={bst} sx={{marginBottom: 6}} control={<Checkbox />} label="Prenota tutti i BST" />}
                     
                        <div style={{display: 'flex'}}>
                            <CustomButton text="Vai avanti" onClick={async () => {
                                try{
                                    if(!posizione || !bandiera || posizione === "" || bandiera === ""){
                                        alert("È obbligatorio specificare la posizione e la bandiera");
                                        return;
                                    }
                                    const user = await AuthHelper.getUserFromIdToken();
                                    const res = await fetch(`https://3vuz0d85jk.execute-api.eu-west-1.amazonaws.com/mase/api/v1/user/profile/documents/${user.Username}`);

                                    let documents = (await res.json()).map(x => x.name);
                                    
                                    const requiredDocuments = {
                                        primo_imbarco: [
                                            "Codice Fiscale",
                                            "Lettera d\'ingaggio",
                                            "Foglio provvisorio"
                                        ],
                                        sbarcato: [
                                            "Codice Fiscale",
                                            "Prima pagina libretto di navigazione",
                                        ],
                                        imbarcato: [
                                            "Codice Fiscale",
                                            "Lettera di licenza",
                                            "Prima pagina libretto di navigazione",
                                        ]
                                    }

                                    let nDocuments = 0;
                                    let documentsDone = []
                                    for(let document of documents){
                                        if(requiredDocuments[posizione].includes(document)){
                                            nDocuments += 1;
                                            documentsDone.push(document)
                                        }
                                    }
                                    
                                    if(requiredDocuments[posizione]?.length === nDocuments){
                                        if(bandiera === 'italiana' && posizione === 'sbarcato'){
                                            if(!documents.includes('Pagina libretto ultimo imb.')){
                                                alert("La pagina dell'ultimo imbarco è obbligatoria");
                                                return;
                                            }
                                        }
                                        if(bandiera === 'estera' && posizione === 'sbarcato'){
                                            if(!documents.includes('Discharge')){
                                                alert("La lettera di discharge è obbligatoria");
                                                return;
                                            }
                                        }
                                        if(documents.includes('Passaporto') || documents.includes("Carta d'identità")){
                                            setPaymentStep(1);
                                        }else{
                                            alert("Il passaporto o la carta d'identità è obbligatoria");
                                            return;
                                        }
                                    }else{
                                        alert(`Non hai i documenti obbligatori per iscriverti al corso: ${requiredDocuments[posizione].filter(document => !documentsDone.includes(document)).length === 1 ? 'Manca' : 'Mancano'} ${requiredDocuments[posizione].filter(document => !documentsDone.includes(document)).join(',')}`);
                                        return;
                                    }
                                }catch(ex){
                                    console.error('ERRORE', ex);
                                }
                            }}></CustomButton>
                        </div>
                        
                    </>}
                    {paymentStep === 1 && <>
                    <Typography variant="h6" component="h2" sx={{mb: 2}}>
                        Seleziona il centro di formazione
                    </Typography>
                    {schoolCourses.sort((a,b) => moment(a['from']).diff(moment(b['from']))).map(course => (
                        <Box sx={{display: 'flex', flexDirection: 'column', gap: 2}}>
                        <CardMaterial>
                            <CardContent>
                                <Typography variant="h5" component="div">
                                    {course.school_name}
                                </Typography>
                                <Typography sx={{ mb: 1.5 }} color="text.secondary">
                                    {course['nome corso']}
                                </Typography>
                                <Typography variant="body2">
                                    Da: {moment(course['from']).format('DD/MM/YYYY')} - A: {moment(course['to']).format('DD/MM/YYYY')}<br />
                                    {Number(course['price']).toLocaleString('it-IT', {style: 'currency', currency: 'EUR'})}
                                </Typography>
                            </CardContent>
                            <CardActions>
                                <LoadingButton size="small" variant="contained" onClick={() => createPaymentIntent(course['price'], course)}>Iscriviti ora</LoadingButton>
                            </CardActions>
                        </CardMaterial>
                        </Box>
                    ))}
                  
                    </>}
                    {paymentStep === 2 && <StripeElement />}
                </Box>
        </Modal>
        <Modal
                open={modalOpen}
                onClose={() => setModalOpen(false)}
                aria-labelledby="modal-modal-title"
                aria-describedby="modal-modal-description"
            >
                <Box sx={modalStyleCertificate}>
                    <Typography variant="h6" component="h2">
                        Carica Corso
                    </Typography>
                    <Box sx={{display: 'flex', flexDirection: 'column', gap: 2}}>
                        <input
                            type="file"
                            onChange={handleChange}
                            ref={hiddenFileInput}
                            style={{ display: "none" }} // Make the file input element invisible
                        />
                        <TextField
                            margin="normal"
                            required
                            fullWidth
                            id="id"
                            label="Numero"
                            name="id"
                            onChange={(e) => setCertificate({...certificate, number: e.target.value})}
                        />
                        <FormControl>  
                            <InputLabel id="demo-simple-select-helper-label">Tipologia certificato</InputLabel>

                            <Select
                                label="Tipologia certificato"
                                onChange={(e) => setCertificate({...certificate, course: e.target.value})}
                                value={certificate.course}
                            >
                                <MenuItem></MenuItem>
                                {courses?.sort().map(course => (
                                    <MenuItem value={course['id']}>{course['nome corso']}</MenuItem>
                                ))}
                            </Select>
                        </FormControl>
                        <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale={it}>
                            <DemoContainer components={['DatePicker']}>
                                <DatePicker label="Data di Rilascio" maxDate={dayjs()} onChange={(e) => setCertificate({...certificate, release: moment(e.toDate()).format('YYYY-MM-DD')})} format="DD/MM/YYYY"/>
                            </DemoContainer>
                        </LocalizationProvider>

                        <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale={it}>
                            <DemoContainer components={['DatePicker']}>
                                <DatePicker label="Data di scadenza" minDate={dayjs(certificate.release).add(3, 'years')} maxDate={dayjs(certificate.release).add(5, 'years')} onChange={(e) => setCertificate({...certificate, expiry: moment(e.toDate()).format('YYYY-MM-DD')})} format="DD/MM/YYYY"/>
                            </DemoContainer>
                        </LocalizationProvider>

                        <Button onClick={handleClick}>Carica il pdf</Button>

                        <LoadingButton variant="contained" onClick={() => loadCertificate()} loading={loading}>Carica</LoadingButton>

                    </Box>
                </Box>
        </Modal>
        <Modal
                open={fileModal}
                onClose={() => setFileModal(false)}
                aria-labelledby="modal-modal-title"
                aria-describedby="modal-modal-description"
                sx={{marginTop: 0, paddingTop: 0}}
            >
                <Box sx={modalStyleDocument}>
                    <Typography variant="h6" component="h2">
                        Carica Documento
                    </Typography>
                    <Box sx={{display: 'flex', flexDirection: 'column', gap: 2}}>
                        <input
                            type="file"
                            onChange={handleChange}
                            ref={hiddenFileInput}
                            style={{ display: "none" }} // Make the file input element invisible
                        />
                        <TextField
                            margin="normal"
                            required
                            fullWidth
                            id="id"
                            label="Numero"
                            name="id"
                            
                            onChange={(e) => setDocument({...document, number: e.target.value})}
                        />
                        
                        <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale={it}>
                            <DemoContainer components={['DatePicker']}>
                                <DatePicker label="Data di Rilascio" maxDate={dayjs()} format="DD/MM/YYYY" onChange={(e) => setDocument({...document, released: moment(e.toDate()).format('YYYY-MM-DD')})}/>
                            </DemoContainer>
                        </LocalizationProvider>

                        <LocalizationProvider dateAdapter={AdapterDayjs } adapterLocale={it}>
                            <DemoContainer components={['DatePicker']}>
                                <DatePicker label="Data di scadenza" format="DD/MM/YYYY" onChange={(e) => setDocument({...document, expire: moment(e.toDate()).format('YYYY-MM-DD')})}/>
                            </DemoContainer>
                        </LocalizationProvider>

                        <Button onClick={handleClick}>Carica il documento</Button>

                        <LoadingButton variant="contained" onClick={() => loadDocument()} loading={loading}>Salva</LoadingButton>

                    </Box>
                </Box>
        </Modal>
        <Modal
                open={modalProfile}
                onClose={() => setModalProfile(false)}
                aria-labelledby="modal-modal-title"
                aria-describedby="modal-modal-description"
                sx={{overflow: 'scroll', width: '100%'}}
            >
                <Box sx={modalStyle}>
                    <div style={{display: 'flex', justifyContent: 'space-between', paddingLeft: 16, paddingRight: 16}}>
                        <Typography variant="h6" component="h2">
                            Modifica Profilo
                        </Typography>
                        <div onClick={() => setModalProfile(false)}>
                            <CancelOutlined />
                        </div>
                    </div>
                    
                    <Box sx={{display: 'flex', flexDirection: 'column', gap: 2, pl: 2, pr: 2, pb: 3}}>
                       
                        <TextField
                            margin="normal"
                            fullWidth
                            id="id"
                            label="Nome"
                            placeholder="Nome"
                            name="id"
                            onChange={(e) => setProfile({...profile, first_name: e.target.value})}
                        />
                        <TextField
                            margin="normal"
                            fullWidth
                            id="id"
                            label="Cognome"
                            placeholder="Cognome"
                            name="id"
                            onChange={(e) => setProfile({...profile, last_name: e.target.value})}
                        />
                        <FormControl>  
                        <InputLabel id="demo-simple-select-helper-label">Genere</InputLabel>

                        <Select
                            label="Tipologia nave"
                            onChange={(e) => setProfile({...profile, gender: e.target.value})}
                        >
                            <MenuItem></MenuItem>
                            <MenuItem value={'M'}>Maschio</MenuItem>
                            <MenuItem value={'D'}>Donna</MenuItem>
                        </Select>
                        </FormControl>
                        <FormControl>  
                        <InputLabel id="demo-simple-select-helper-label">Nazione</InputLabel>

                        <Select
                            label="Nazione"
                            onChange={(e) => setProfile({...profile, nation: e.target.value})}
                        >
                            <MenuItem></MenuItem>
                            {["United States", "Canada", "Afghanistan", "Albania", "Algeria", "American Samoa", "Andorra", "Angola", "Anguilla", "Antarctica", "Antigua and/or Barbuda", "Argentina", "Armenia", "Aruba", "Australia", "Austria", "Azerbaijan", "Bahamas", "Bahrain", "Bangladesh", "Barbados", "Belarus", "Belgium", "Belize", "Benin", "Bermuda", "Bhutan", "Bolivia", "Bosnia and Herzegovina", "Botswana", "Bouvet Island", "Brazil", "British Indian Ocean Territory", "Brunei Darussalam", "Bulgaria", "Burkina Faso", "Burundi", "Cambodia", "Cameroon", "Cape Verde", "Cayman Islands", "Central African Republic", "Chad", "Chile", "China", "Christmas Island", "Cocos (Keeling) Islands", "Colombia", "Comoros", "Congo", "Cook Islands", "Costa Rica", "Croatia (Hrvatska)", "Cuba", "Cyprus", "Czech Republic", "Denmark", "Djibouti", "Dominica", "Dominican Republic", "East Timor", "Ecudaor", "Egypt", "El Salvador", "Equatorial Guinea", "Eritrea", "Estonia", "Ethiopia", "Falkland Islands (Malvinas)", "Faroe Islands", "Fiji", "Finland", "France", "France, Metropolitan", "French Guiana", "French Polynesia", "French Southern Territories", "Gabon", "Gambia", "Georgia", "Germany", "Ghana", "Gibraltar", "Greece", "Greenland", "Grenada", "Guadeloupe", "Guam", "Guatemala", "Guinea", "Guinea-Bissau", "Guyana", "Haiti", "Heard and Mc Donald Islands", "Honduras", "Hong Kong", "Hungary", "Iceland", "India", "Indonesia", "Iran (Islamic Republic of)", "Iraq", "Ireland", "Israel", "Italy", "Ivory Coast", "Jamaica", "Japan", "Jordan", "Kazakhstan", "Kenya", "Kiribati", "Korea, Democratic People's Republic of", "Korea, Republic of", "Kosovo", "Kuwait", "Kyrgyzstan", "Lao People's Democratic Republic", "Latvia", "Lebanon", "Lesotho", "Liberia", "Libyan Arab Jamahiriya", "Liechtenstein", "Lithuania", "Luxembourg", "Macau", "Macedonia", "Madagascar", "Malawi", "Malaysia", "Maldives", "Mali", "Malta", "Marshall Islands", "Martinique", "Mauritania", "Mauritius", "Mayotte", "Mexico", "Micronesia, Federated States of", "Moldova, Republic of", "Monaco", "Mongolia", "Montserrat", "Morocco", "Mozambique", "Myanmar", "Namibia", "Nauru", "Nepal", "Netherlands", "Netherlands Antilles", "New Caledonia", "New Zealand", "Nicaragua", "Niger", "Nigeria", "Niue", "Norfork Island", "Northern Mariana Islands", "Norway", "Oman", "Pakistan", "Palau", "Panama", "Papua New Guinea", "Paraguay", "Peru", "Philippines", "Pitcairn", "Poland", "Portugal", "Puerto Rico", "Qatar", "Reunion", "Romania", "Russian Federation", "Rwanda", "Saint Kitts and Nevis", "Saint Lucia", "Saint Vincent and the Grenadines", "Samoa", "San Marino", "Sao Tome and Principe", "Saudi Arabia", "Senegal", "Seychelles", "Sierra Leone", "Singapore", "Slovakia", "Slovenia", "Solomon Islands", "Somalia", "South Africa", "South Georgia South Sandwich Islands", "South Sudan", "Spain", "Sri Lanka", "St. Helena", "St. Pierre and Miquelon", "Sudan", "Suriname", "Svalbarn and Jan Mayen Islands", "Swaziland", "Sweden", "Switzerland", "Syrian Arab Republic", "Taiwan", "Tajikistan", "Tanzania, United Republic of", "Thailand", "Togo", "Tokelau", "Tonga", "Trinidad and Tobago", "Tunisia", "Turkey", "Turkmenistan", "Turks and Caicos Islands", "Tuvalu", "Uganda", "Ukraine", "United Arab Emirates", "United Kingdom", "United States minor outlying islands", "Uruguay", "Uzbekistan", "Vanuatu", "Vatican City State", "Venezuela", "Vietnam", "Virigan Islands (British)", "Virgin Islands (U.S.)", "Wallis and Futuna Islands", "Western Sahara", "Yemen", "Yugoslavia", "Zaire", "Zambia", "Zimbabwe"].map(x => <MenuItem value={x}>{x}</MenuItem>)}
                        </Select>
                        </FormControl>
                        <TextField
                            margin="normal"
                            fullWidth
                            id="id"
                            label="Indirizzo"
                            name="id"
                            onChange={(e) => setProfile({...profile, address: e.target.value})}
                        />
                        <TextField
                            margin="normal"
                            fullWidth
                            id="id"
                            label="Numero civico"
                            name="id"
                            onChange={(e) => setProfile({...profile, civic_number: e.target.value})}
                        />
                        <TextField
                            margin="normal"
                            fullWidth
                            id="id"
                            label="Città di residenza"
                            name="id"
                            onChange={(e) => setProfile({...profile, city_residence: e.target.value})}
                        />
                        <TextField
                            margin="normal"
                            fullWidth
                            id="id"
                            label="Provincia di residenza"
                            name="id"
                            onChange={(e) => setProfile({...profile, province_residence: e.target.value})}
                        />
                        <TextField
                            margin="normal"
                            fullWidth
                            id="id"
                            label="CAP"
                            name="id"
                            onChange={(e) => setProfile({...profile, postal_code: e.target.value})}
                        />
                        <TextField
                            margin="normal"
                            fullWidth
                            id="id"
                            label="Luogo di nascita"
                            name="id"
                            onChange={(e) => setProfile({...profile, birthplace: e.target.value})}
                        />
                        <TextField
                            margin="normal"
                            fullWidth
                            id="id"
                            label="Provincia di Nascita"
                            name="id"
                            onChange={(e) => setProfile({...profile, birth_province: e.target.value})}
                        />
                         <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale={it}>
                            <DemoContainer components={['DatePicker']}>
                                <DatePicker format={"DD/MM/YYYY"} label="Data di nascita" fullWidth maxDate={dayjs().subtract(18, 'year')} onChange={(e) => setProfile({...profile, birthday: moment(e.toDate()).format('YYYY-MM-DD')})} slotProps={{
    textField: {
      helperText: 'Seleziona una data di nascita valida',
    },
  }}/>
                            </DemoContainer>
                        </LocalizationProvider>
                        <TextField
                            margin="normal"
                            fullWidth
                            id="id"
                            label="Codice Fiscale"
                            name="id"
                            onChange={(e) => setProfile({...profile, fiscal_code: e.target.value})}
                        />
                       
                        <TextField
                            margin="normal"
                            fullWidth
                            id="id"
                            label="Numero di telefono"
                            name="id"
                            onChange={(e) => setProfile({...profile, phone_number: e.target.value})}
                        />
                        <Button variant="contained" onClick={() => postProfile()}>Salva</Button>

                    </Box>
                </Box>
        </Modal>
        <Box sx={{ width: '100%', position: 'relative', top: '-125px'}}>
            <div style={{
                display: 'block',
                width: '100%',
                height: 125,
                textAlign: 'right',
                marginBottom: 12,
                position: 'relative',
                top: '45px'
            }}>
                    <img src="/images/New Logo MASE  TR2 mod.png" style={{
                        width: 125,
                        height: 125,
                    }}/>
            </div>
            <Wave fill='rgb(6, 32, 105)'
        paused={false}
        style={{ display: 'flex', position: 'relative', bottom: '-5px'}}
        options={{
          height: 20,
          amplitude: 20,
          speed: 0.15,
          points: 3
        }}
  />
        <div style={style.container}>
                <input
                    type="file"
                    onChange={handleAvatarChange}
                    ref={hiddenAvatarInput}
                    style={{ display: "none" }} // Make the file input element invisible
                />
                <div style={{backgroundColor: 'white', borderRadius: '100%', top: -85, position: 'absolute', objectFit: 'cover', display: 'flex', alignItems: 'center'}}>
                    <img onClick={() => hiddenAvatarInput.current?.click()} src={profile?.avatar ? profile?.avatar : avatar} width={125} height={125} alt="logo" style={{borderRadius: 6666, objectFit: 'cover'}} />
                    <AddAPhotoIcon sx={{position: 'absolute', right: 0, bottom: 10}} htmlColor="#555555" />
                </div>
                <div style={{display: 'flex', flexDirection: 'row', justifyContent: 'space-between', flexWrap: 'wrap', rowGap: 12, paddingTop: 115, textAlign: 'left'}}>
                <div style={{width: '45%', display: 'flex', flexDirection: 'column', color: '#fff'}}><span>NOME</span><strong>{_user.length > 0 && `${_user.filter(x => x.Name === 'name')[0].Value}`}</strong></div>
                <div style={{width: '45%', display: 'flex', flexDirection: 'column', color: '#fff'}}><span>COGNOME</span><strong>{_user.length > 0 && `${_user.filter(x => x.Name === 'family_name')[0].Value}`}</strong></div>
                <div style={{width: '45%', display: 'flex', flexDirection: 'column', color: '#fff'}}><span>DATA DI NASCITA</span><strong>{profile.birthday && profile.birthday !== "" ? moment(profile.birthday).format('DD/MM/YYYY') : 'Da inserire.'}</strong></div>
                <div style={{width: '100%', display: 'flex', flexDirection: 'column', color: '#fff'}}><span>E-MAIL</span><strong>{_user.length > 0 && `${_user.filter(x => x.Name === 'email')[0].Value}`}</strong></div>

                <div style={{width: '100%', display: 'flex', flexDirection: 'column', color: '#fff'}}><span>NUMERO DI TELEFONO</span><strong>{profile.phone_number}</strong></div>
                <div style={{width: '100%'}}><FormControlLabel control={<Switch  color='success' />} style={{color: '#fff'}} label="Disponibile all'imbarco" onChange={async (e, newValue) => {
                    const res = await fetch(`https://0lp9rmohf7.execute-api.eu-west-1.amazonaws.com/mase2/api/v1/availability/${profile.id}`, {
                        method: 'PUT',
                        body: JSON.stringify({
                            availability: newValue
                        })
                    });
                    setProfile({...profile, available: newValue});
                }} checked={profile.available} /></div>

                <CustomButton text="Modifica" style={{margin: '0 auto', marginTop: 24}} onClick={() => setModalProfile(true)}></CustomButton>
                {/* <CustomButton text="Reset" style={{margin: '0 auto', marginTop: 24}} onClick={() => resetButton()}></CustomButton> */}
                <CustomButton text="Logout" style={{margin: '0 auto', marginTop: 24}} onClick={() => logoutButton()}></CustomButton>
                <CustomButton text="Privacy Policy" style={{margin: '0 auto', marginTop: 24}} onClick={() => window.location.href="https://www.iubenda.com/privacy-policy/54496977"}></CustomButton>
                <CustomButton text="Termini e condizioni" style={{margin: '0 auto', marginTop: 24}} onClick={() => window.location.href = "https://www.iubenda.com/termini-e-condizioni/54496977"}></CustomButton>
                <CustomButton text="Elimina account" style={{margin: '0 auto', marginTop: 24}} onClick={async() => {
                    if(window.confirm('Sei sicuro che vuoi eliminare l\'account?')){
                        const username = await AuthHelper.getUserFromIdToken()
                        await AuthHelper.deleteUser(username['Username']);
                        window.location.href = '/login'
                    }
                }}></CustomButton>
                <CustomButton text="Cambia ruolo" style={{margin: '0 auto', marginTop: 24}} onClick={() => setOpenChangeRole(true)}></CustomButton>

                <div style={{height: 300, width: '100%', display: 'flex', justifyContent: 'space-between', alignItems: 'center'}}>
                    <div style={{width: 150}}><CircularProgressbar strokeWidth={5} styles={buildStyles({
                        strokeLinecap: 'butt',
                        textSize: '31px',
                        pathTransitionDuration: 0.5,
                        pathColor: `#fff`,
                        textColor: '#fff',
                        trailColor: 'rgba(255,255,255,.3)',
                        backgroundColor: '#3e98c7',
                    })} value={completedPercentage * 100 > 100 ? 100 : completedPercentage * 100} text={`${parseInt(completedPercentage * 100 > 100 ? 100 : completedPercentage * 100)}%`}/></div>
                    {(completedPercentage * 100) >= 100 ?
                    <strong style={{color: '#fff', paddingLeft: 15}}>Complimenti! <br/>Il tuo profilo è completo!</strong>
                    :
                    <strong style={{color: '#fff', paddingLeft: 15}}>Il tuo profilo non è ancora completo
                    <ul style={{paddingLeft: 15, fontWeight: 'normal'}}>
                    {nextRole.remainingMonths > 0 && <li>Ti rimangono {nextRole.remainingMonths} mesi di navigazione</li>}
                    {nextRole.remainingCourses?.length > 0 && <li>Ti riman{[...new Set(nextRole.remainingIds)]?.length > 1 ? 'gono' : 'e'} {[...new Set(nextRole.remainingIds)]?.length} cors{[...new Set(nextRole.remainingIds)]?.length > 1 ? 'i' : 'o'} da conseguire</li>}
                    {completedProfilePercentage > 0 && <li>Devi inserire tutti i dati anagrafici</li>}
                    </ul></strong>
                    }
                </div>
                
                </div>
            </div>
        <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
            <Tabs value={value} onChange={handleChangeTab} aria-label="basic tabs example" sx={{justifyContent: 'space-between'}}>
                <Tab label="Documenti" {...a11yProps(0)} />
                <Tab label="Corsi & Certificato IMO STCW" {...a11yProps(1)} />
            </Tabs>
        </Box>
        <CustomTabPanel value={value} index={0}>
            
            <div style={{paddingLeft: 26, paddingRight: 26}}>
                <span style={{fontSize: '2rem', fontWeight: 600, color: '#3d4a71', marginBottom: 12, marginTop: '2rem', display: 'block'}}>I tuoi documenti</span>
                <div className="carousel" style={{display: 'flex', width: '100%', overflow: 'auto', padding: 26, transform: 'translateX(-26px)'}}>{
                    documents.length > 0 && documents.map((item) => (<>
                        <Card item={{...item, expiry: item.expire}} expired={moment(item.expire).diff(moment(), 'months') <= 5 && moment(item.expire).diff(moment(), 'days') < 0} icon={<div style={{display: 'flex', flexWrap: 'wrap'}} >
                        <span style={{width: '100%', marginBottom: 12}}>{item.name}</span>    <br />
                        <VisibilityIcon fontSize="medium" onClick={() => {
                            window.location.href="/iframe?url="+item.file;
                        }}></VisibilityIcon> 
                        <DownloadIcon onClick={() => downloadPdf(item.file)} fontSize="medium" /> 
                        <ShareIcon onClick={() => navigator.share({title: 'Voglio condividere il mio corso con te', text: `Visualizza il mio documento ${item.name} al link: ${item.file}`, url: item.file})} fontSize="medium" />
                        <DeleteIcon onClick={async () => {
                            const res = await fetch(`https://0lp9rmohf7.execute-api.eu-west-1.amazonaws.com/mase2/api/v1/documents/${item.id}`, {
                                method: 'DELETE'
                            })
                            if(res.status === 200){
                                alert("Documento eliminato con successo");

                                await findDocuments();
                            }
                        }} fontSize="medium" /></div>} text={item.number} widgets={[{title: 'Emesso', description: moment(item.released).format('DD/MM/YYYY')}, {title: 'Scadenza', description: moment(item.expire).format('DD/MM/YYYY')}]} />
                        </>
                    ))}</div>
            </div>
        
            {documents.length === 0 && <div style={{width: '100%', textAlign: 'center'}}>
                    <p style={{textAlign: 'center', paddingBottom: 24, marginTop: 0}}>Non hai caricato nessun documento.</p>
            </div>}
            <CustomButton text="Carica documento" onClick={(e) => {setAnchorEl(e.currentTarget); setOpen(true)}} />
            <div style={{width: 100}}><Menu
                id={'menu'}
                open={open && !fileModal}
                anchorEl={anchorEl}
                onClose={() => setOpen(false)}
                anchorOrigin={{
                    vertical: 'top',
                    horizontal: 'left',
                }}
                transformOrigin={{
                    vertical: 'top',
                    horizontal: 'left',
                }}
            >
                <MenuItem onClick={() => {
                    openFileModal('Codice Fiscale');
                }}>Codice Fiscale</MenuItem>
                <MenuItem onClick={() => {
                    openFileModal('Passaporto');
                }}>Passaporto</MenuItem>
                <MenuItem onClick={() => {
                    openFileModal('Carta d\'identità');
                }}>Carta d'identità</MenuItem>
                <MenuItem onClick={() => {
                    openFileModal('Lettera d\'ingaggio');
                }}>Lettera d'ingaggio</MenuItem>
                <MenuItem onClick={() => {
                    openFileModal('Visita Biennale');
                }}>Visita Biennale</MenuItem>
                <MenuItem onClick={() => {
                    openFileModal('Lettera di licenza');
                }}>Lettera di licenza</MenuItem>
                <MenuItem onClick={() => {
                    openFileModal('Pagina libretto ultimo imb.');
                }}>Pagina libretto ultimo imb.</MenuItem>
                <MenuItem onClick={() => {
                    openFileModal('Discharge');
                }}>Discharge</MenuItem>
                {/* <MenuItem onClick={() => {
                    openFileModal('Autocertificazione');
                }}>Autocertificazione</MenuItem> */}
                <MenuItem onClick={() => {
                    openFileModal('Prima pagina libretto di navigazione');
                }}>Prima pagina libretto di navigazione</MenuItem>
                <MenuItem onClick={() => {
                    openFileModal('Foglio provvisorio');
                }}>Foglio provvisorio</MenuItem>
                <MenuItem onClick={() => {
                    openFileModal('Certificato Carichi Pendenti');
                }}>Certificato carichi pendenti</MenuItem>
                <MenuItem onClick={() => {
                    openFileModal('Cadet Record Book');
                }}>Cadet Record Book</MenuItem>
                <MenuItem onClick={() => {
                    openFileModal('Curriculum Vitae');
                }}>Curriculum Vitae</MenuItem>
            </Menu>
            
            </div>
        </CustomTabPanel>
        <CustomTabPanel value={value} index={1}>
            {imo && <>
            <CustomButton 
            aria-controls={openIMO ? 'basic-menu' : undefined}
            aria-haspopup="true"
            aria-expanded={openIMO ? 'true' : undefined}
            text="Certificato IMO" style={{margin: '0 auto', marginTop: 24}} onClick={(e) => {
                setAnchorElIMO(e.currentTarget);
            }} ></CustomButton>
            <Menu
                id="basic-menu"
                anchorEl={anchorElIMO}
                open={openIMO}
                onClose={() => setAnchorElIMO(null)}
                MenuListProps={{
                'aria-labelledby': 'basic-button',
                }}
            >
                <MenuItem onClick={() => {window.location.href="/iframe?url="+imo}}>Visualizza</MenuItem>
                <MenuItem onClick={() => {}}>Elimina</MenuItem>
            </Menu>
            </>}
            <br/>
            {rolesPDF[roleId] && <>
            <CustomButton text="Scarica il Cadet Record Book" style={{margin: '0 auto', marginTop: 24}} onClick={() => {
                downloadPdf(rolesPDF[roleId])
            }}></CustomButton>
            <br /><strong>Nota importante: Caricare il cadet record book compilato a penna per sbloccare l'esame.</strong>
            </>}
            

            <span style={{fontSize: '2rem', fontWeight: 600, color: '#3d4a71', marginTop: 24, marginBottom: 12, display: 'block'}}>I tuoi Corsi</span>
            <div className="carousel" style={{display: 'flex', width: '100%', overflow: 'auto', padding: 26, transform: 'translateX(-26px)'}}>{
                certificates?.length > 0 ? certificates?.map((item) => (<>
                    <Card item={item} expired={moment(item.expiry).diff(moment(), 'months') <= 5 && moment(item.expiry).diff(moment(), 'days') < 0} prova='props' icon={<div style={{display: 'flex', gap: 3}}>
                        <VisibilityIcon onClick={() => {
                            window.location.href="/iframe?url="+item.pdf
                        }}></VisibilityIcon> 
                        <DownloadIcon onClick={() => downloadPdf(item.pdf)} /> <ShareIcon onClick={() => navigator.share({title: 'Voglio condividere il mio corso con te', text: `Visualizza il mio corso ${item.course['nome corso']} al link: ${item.pdf}`, url: item.pdf})}  />
                        <DeleteIcon onClick={async () => {
                            const res = await fetch(`https://3vuz0d85jk.execute-api.eu-west-1.amazonaws.com/mase/api/v1/certificates/${item.id}`, {
                                method: 'DELETE'
                            })
                            if(res.status === 200){
                                alert("Corso eliminato con successo");
                                await getCertificates();
                            }
                        }} fontSize="medium" />
                        {moment(item.expiry).diff(moment(), 'months') <= 5 && moment(item.expiry).diff(moment(), 'days') >= 0 && <Button variant="contained" size="small" onClick={() => {
                         
                            setCertificate({...certificate,
                                id: item.id,
                                course: item.course.id,
                                expiry: moment(item.expiry)
                            })
                            findSchools(item.course.refresh);

                            
                        }} sx={{ml: 6, backgroundColor: '#ff0f0f'}}>Rinnova</Button>}
                        {moment(item.expiry).diff(moment(), 'months') <= 5 && moment(item.expiry).diff(moment(), 'days') < 0 && <Button variant="contained" size="small" onClick={() => {
                            
                            setCertificate({...certificate,
                                id: item.id,
                                course: item.course.id,
                                expiry: moment(item.expiry)
                            })
                            findSchools(item.course.id);

                            return;
                            setCertificate({...item});
                            
                        }} sx={{ml: 6, backgroundColor: '#ff0f0f'}}>Rifai</Button>}
                        </div>} text={item.course['nome corso']} widgets={[{title: 'Conseguito', description: moment(item.release).format('DD/MM/YYYY')}, {title: 'Scade', description: moment(item.expiry).format('DD/MM/YYYY')}]} 
                        
                    />
                    </>
                )) : <div style={{width: '100%', textAlign: 'center'}}>
                    <p style={{textAlign: 'center', paddingBottom: 24, marginTop: 0}}>Non hai caricato nessun certificato.</p>
                    {/* <CustomButton text="Carica un corso" onClick={() => setModalOpen(true)} /> */}
                    </div>
            }</div>
            {nextRole?.name && <>
                <hr/>

                <Typography width={218} textTransform={'uppercase'} textAlign="center" justifyContent={"center"} margin="0 auto" color="#626262" fontFamily="Roboto" fontSize="12px" sx={{marginTop: '12px'}}>Grado attuale</Typography>
                <Typography textTransform={'uppercase'} textAlign="center" justifyContent={"center"} margin="0 auto" marginTop="5px" color="#1B2B58" fontFamily="Spectral" fontSize="15px" fontWeight="bold">{nextRole.name}</Typography>
                <div style={{width: '100%', display: 'flex', justifyContent: 'center'}}>
              
                <CardCertificati 
                notOnlyRequired
                icon={<div style={{width: 95, height: 95}}><CircularProgressbar strokeWidth={5} styles={buildStyles({
                    strokeLinecap: 'butt',
                    textSize: '31px',
                    pathTransitionDuration: 0.5,
                    pathColor: `#1B2B58`,
                    textColor: '#1B2B58',
                    trailColor: '#d6d6d6',
                    backgroundColor: '#3e98c7',
                })} value={nextRole.percentage} text={`${nextRole.percentage}%`}/></div>} 
                durability={`${nextRole.remainingMonths}`}
                onExternalLoad={loadExternalCourse}
                description={`Di navigazione come ${role?.role ? role.role : null}`}
                onFindSchool={findSchools}
                info={nextRole?.informative}
                certificates={
                    [...nextRole?.remainingCourses?.map(x => ({name: x['nome corso'], registry: x['reg. stcw'], ...x})), ...nextRole?.remainingCoursesPropedeutici?.map(x => ({name: x['nome corso'], registry: x['reg. stcw'], ...x, "obbligatorieta'": 'PROPEDEUTICO'}))]
                }
                />
                </div>
            </>}
        </CustomTabPanel>
        </Box>
        <Fab onClick={(e) => {window.location.href = "/"}} sx={{color: 'primary.main', background: '#fff'}} color="inherit" aria-label="add" style={{position: 'fixed', right: 12, bottom: '4.5rem'}}>
                <SchoolRounded />
        </Fab>
    </div>
  
    )
    
}

export default Profile;